import { ADMIN_REPORT_PATHS } from './adminReportCatalog';

/** Sous-nav réception. */
export const ADMIN_RECEPTION_NAV = [
  {
    to: ADMIN_REPORT_PATHS.RECEPTION_PASSAGES,
    end: true,
    labelKey: 'SUB_PASSAGES',
    navKey: 'reporting'
  },
  {
    to: ADMIN_REPORT_PATHS.RECEPTION_RDV,
    end: false,
    labelKey: 'SUB_RDV',
    navKey: 'rendezVous'
  }
];

/** Sous-nav clinique (médecin chef) — sans rapport infirmier (domaine Infirmerie). */
export const ADMIN_CLINIQUE_NAV = [
  {
    to: ADMIN_REPORT_PATHS.CLINIQUE_SYNTHESE,
    end: true,
    labelKey: 'SUB_SYNTHESE',
    navKey: 'statistiquesSynthese'
  },
  {
    to: ADMIN_REPORT_PATHS.CLINIQUE_CONSULTATIONS,
    end: false,
    labelKey: 'SUB_CONSULTATIONS',
    navKey: 'statistiquesConsultations'
  },
  {
    to: ADMIN_REPORT_PATHS.CLINIQUE_REPOS,
    end: false,
    labelKey: 'SUB_REPOS',
    navKey: 'statistiquesRepos'
  },
  {
    to: ADMIN_REPORT_PATHS.CLINIQUE_MORBIDITE,
    end: false,
    labelKey: 'SUB_MORBIDITE',
    navKey: 'statistiquesMorbidite'
  },
  {
    to: ADMIN_REPORT_PATHS.CLINIQUE_PATHOLOGIES,
    end: false,
    labelKey: 'SUB_PATHOLOGIES',
    navKey: 'statistiquesPathologies'
  },
  {
    to: ADMIN_REPORT_PATHS.CLINIQUE_ORDONNANCES,
    end: false,
    labelKey: 'SUB_ORDONNANCES',
    navKey: 'statistiquesOrdonnances'
  },
  {
    to: ADMIN_REPORT_PATHS.CLINIQUE_MEDICAMENTS,
    end: false,
    labelKey: 'SUB_MEDICAMENTS',
    navKey: 'statistiquesMedicaments'
  },
  {
    to: ADMIN_REPORT_PATHS.CLINIQUE_EXAMENS,
    end: false,
    labelKey: 'SUB_EXAMENS',
    navKey: 'statistiquesExamens'
  }
];

/** Sous-nav infirmerie (major). */
export const ADMIN_NURSING_ANALYTICS_NAV = [
  {
    to: ADMIN_REPORT_PATHS.INFIRMERIE,
    end: true,
    labelKey: 'SUB_OVERVIEW',
    navKey: 'reportsOverview'
  },
  {
    to: ADMIN_REPORT_PATHS.INFIRMERIE_SOINS,
    end: false,
    labelKey: 'SUB_SOINS',
    navKey: 'reportsSoins'
  },
  {
    to: ADMIN_REPORT_PATHS.INFIRMERIE_INJECTIONS,
    end: false,
    labelKey: 'SUB_INJECTIONS',
    navKey: 'reportsInjections'
  },
  {
    to: ADMIN_REPORT_PATHS.INFIRMERIE_TESTS,
    end: false,
    labelKey: 'SUB_TESTS',
    navKey: 'reportsTests'
  },
  {
    to: ADMIN_REPORT_PATHS.INFIRMERIE_VACCINS,
    end: false,
    labelKey: 'SUB_VACCINS',
    navKey: 'reportsVaccins'
  },
  {
    to: ADMIN_REPORT_PATHS.INFIRMERIE_PF,
    end: false,
    labelKey: 'SUB_PLANNING_FAMILIAL',
    navKey: 'reportsPlanningFamilial'
  }
];

/** @deprecated */
export const ADMIN_ANALYTICS_NAV = ADMIN_CLINIQUE_NAV;
